var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckResetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1575 9.43348C34.7256 7.45874 29.7741 6.96952 25.0414 8.03881C20.3088 9.10809 16.0485 11.6786 12.8961 15.3669C9.74372 19.0552 7.86802 23.6637 7.54878 28.5052C7.22953 33.3466 8.48385 38.1616 11.1247 42.2319C13.7655 46.3022 17.6513 49.4098 22.2026 51.0913C26.7538 52.7728 31.7267 52.938 36.3796 51.5623C41.0324 50.1866 45.1159 47.3437 48.021 43.4576C50.9261 39.5715 52.4972 34.8504 52.5 29.9985V27.6999C52.5 26.3192 53.6193 25.1999 55 25.1999C56.3807 25.1999 57.5 26.3192 57.5 27.6999V29.9999C57.4966 35.9301 55.5764 41.7017 52.0257 46.4514C48.475 51.201 43.484 54.6757 37.7972 56.3571C32.1104 58.0385 26.0325 57.8366 20.4698 55.7814C14.9071 53.7263 10.1578 49.9281 6.93014 44.9533C3.70248 39.9784 2.16943 34.0935 2.55961 28.1762C2.9498 22.2589 5.24232 16.6262 9.09527 12.1183C12.9482 7.61034 18.1552 4.46864 23.9395 3.16174C29.7239 1.85484 35.7757 2.45276 41.1925 4.86634C42.4537 5.42829 43.0205 6.90623 42.4586 8.16741C41.8966 9.42859 40.4187 9.99543 39.1575 9.43348Z",
    fill: "#9F9978"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7669 8.23135C57.7437 9.20717 57.7445 10.7901 56.7687 11.7669L31.7687 36.7919C31.2999 37.2611 30.6639 37.5248 30.0006 37.525C29.3374 37.5252 28.7012 37.2618 28.2322 36.7928L20.7322 29.2928C19.7559 28.3165 19.7559 26.7335 20.7322 25.7572C21.7085 24.7809 23.2915 24.7809 24.2678 25.7572L29.9991 31.4886L53.2313 8.23312C54.2072 7.25632 55.7901 7.25553 56.7669 8.23135Z",
    fill: "#9F9978"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckResetPassword);
export default __webpack_public_path__ + "static/media/check_reset_password.4339ca5100ea175e87543754a442c014.svg";
export { ForwardRef as ReactComponent };